import React from "react";
import { useSelector } from "react-redux";
import { Tabs } from "antd";

const AdminProfile = () => {
  const user = useSelector((state) => state.user.user);

  // Function to render Admin Profile tab content
  const renderAdminProfile = () => {
    return (
      <div>
        <p>Name: {user.name}</p>
        <p>Email: {user.email}</p>
        <p>Phone: {user.phone}</p>
        <p>Status: {user.status === "enable" ? "Active" : "Disabled"}</p>
      </div>
    );
  };

  // Function to render Users Profile tab content
  const renderUsersProfile = () => {
    return (
      <div>
        <h2>Users Profile</h2>
        <p>This section contains users' profiles and information.</p>
        {/* Add more user profile related content here */}
      </div>
    );
  };

  return (
    <Tabs
      centered={true}
      defaultActiveKey="1"
      items={[
        {
          key: "1",
          label: "Admin Profile",
          children: renderAdminProfile(),
        },
        // {
        //   key: "2",
        //   label: "Users Profile",
        //   children: renderUsersProfile(),
        // },
      ]}
    />
  );
};

export default AdminProfile;
